import Vue from 'vue';

new Vue({
    el: '#room-overview-vue-app',
    data() {
        return {
            allRooms: [],
            nodeList: null,
            personsSelector: null,
            personsSelectorButtons: null,
            roomTypeSelector: null,
            roomTypeInputs: null,
            roomTypeLabels: [],
            accessibilityCheckbox: null,
            sortBySelections: null,
            sortBySelector: null,
            showPersonsModal: false,
            showRoomTypesModal: false,
            showSortByModal: false,
            labelValues: {},
            minusAdult: null,
            plusAdult: null,
            minusChildren: null,
            plusChildren: null,
            minusInfants: null,
            plusInfants: null,
            //temp1: [],
            counterType: {
                adultsCounter: document.querySelector("#adultsCounter").value ? document.querySelector("#adultsCounter").value : 0,
                childrenCounter: document.querySelector("#childrenCounter").value ? document.querySelector('#childrenCounter').value : 0,
                infantsCounter: document.querySelector("#infantsCounter").value ? document.querySelector("#infantsCounter").value : 0
            }
        }
    },
    mounted() {
        this.nodeList = document.querySelectorAll(".room-overview__pages__item");

        this.nodeList.forEach((item) => {
            const room = {
                id: item.id,
                roomType: item.dataset.roomtype,
                price: parseFloat(item.dataset.price),
                sortOrder: parseInt(item.dataset.sortorder),
                beds: JSON.parse(item.dataset.beds),
                accessibility: item.dataset.accessibility,
            };

            this.allRooms.push(room);
        });

        // console.log(this.allRooms);

        try {
            this.personsSelector = document.querySelector('.room-select-person ')
            this.personsSelector.addEventListener('click', this.setUpPersonsCountListeners)
            this.personsSelectorButtons = document.querySelectorAll(".people-button")
            this.personsSelectorButtons.forEach(element => {
                element.addEventListener('click', this.filterRooms)
            })
        } catch (e) {
            console.log("Persons filter not present in the DOM");
        }

        try {
            this.roomTypeInputs = document.querySelectorAll(".room-overview__filters__room-type input[type='checkbox']");
            this.roomTypeInputs.forEach(element => {
                element.addEventListener('click', this.filterRooms)
            });;
        } catch (e) {
            console.log("Sort by is not present in the DOM");
        }

        try {
            this.accessibilityCheckbox = document.querySelector('.accessibility-filter-wrapper input');
            this.accessibilityCheckbox.addEventListener('click', this.filterRooms);
        } catch (e) {
            console.log("Accessibility filter is not present in the DOM");
        }

        try {
            this.sortBySelections = document.querySelectorAll(".room-overview__filters__sort-by input[type='radio']");
            this.sortBySelections.forEach(element => {
                element.addEventListener('click', this.filterRooms)
            })
        } catch (e) {
            console.log("Sort by is not present in the DOM");
        }

        // Make it possible to click outside the individual modal to close them
        document.addEventListener('click', this.closePersonModal);
        document.addEventListener('click', this.closeRoomTypesModal);
        document.addEventListener('click', this.closeSortByModal);

    },
    methods: {
        // Main filter method
        filterRooms(e) {
            let rooms = this.allRooms;

            if (this.personsSelectorButtons !== null) {
                rooms = this.personsFilter(rooms)
            }

            if (this.roomTypeInputs !== null) {
                rooms = this.roomTypeFilter(rooms, e);
            }

            if (this.accessibilityCheckbox !== null) {
                rooms = this.accessibilityFilter(rooms);
            }

            if (this.sortBySelections !== null) {
                rooms = this.sortRooms(rooms, e);
            }

            if(rooms.length === 0){
                document.querySelector(".room-overview__pages-no-results").style.display = "flex";
            } else {
                document.querySelector(".room-overview__pages-no-results").style.display = "none";
            }

            this.handleDomElements(rooms);
        },

        // Filters
        personsFilter(rooms) {
            const personsSelectorInputs = document.querySelectorAll(".room-overview__filters__persons input[type='number']")
            personsSelectorInputs.forEach( (personInput, index) => {
                // if(this.temp1.length === 3) {
                //     this.temp1 = [];
                // }
                // this.temp1.push(personInput.value)

                // Adults counter
                if(index === 0) {
                    if(personInput.value > 0) {                        
                        rooms = rooms.filter( room => {
                            let adultBeds = 0;
                            room.beds.forEach( bed => {
                                if(bed.adult){
                                    adultBeds++;
                                }
                            })
                            room.adultBeds = adultBeds;
                            return personInput.value <= room.adultBeds;
                        })
                    }
                // Children counter
                } else if(index === 1) {
                    if(personInput.value > 0) {
                        rooms = rooms.filter( room => {
                            let childrenBeds = 0;
                            room.beds.forEach( bed => {
                                if(bed.child){
                                    childrenBeds++;
                                }
                            })
                            room.childrenBeds = childrenBeds;
                            return personInput.value <= room.childrenBeds;
                        })
                    }
                // Infants counter
                } else if(index === 2) {
                    if(personInput.value > 0) {
                        rooms = rooms.filter( room => {
                            let infantsBeds = 0;
                            room.beds.forEach( bed => {
                                if(bed.infant){
                                    infantsBeds++;
                                }
                            })
                            room.infantsBeds = infantsBeds;
                            return personInput.value <= room.infantsBeds;
                        })
                    }
                }
            })
            
            // Counter values:
            // console.log(this.temp1)

            return rooms;
        },
        roomTypeFilter(rooms, e) {
		    this.roomTypeSelector = document.querySelector(".room-select-room-type")
            let roomTypeSelections = [];

            if(e.target.closest('.room-overview__filters__room-type')) {
                this.updateRoomTypeSelectorFieldOnClick(e)
            }

            // Create array of input value from selected room types
            this.roomTypeInputs.forEach( input => {
                if(input.checked){
                    roomTypeSelections.push(input.value)
                }
            })

            // Filter only if room type filter is selected
            if(roomTypeSelections.length > 0) {
                rooms = rooms.filter(room => roomTypeSelections.includes(room.roomType));
            }

            return rooms;
        },
        accessibilityFilter(rooms) {
            if(this.accessibilityCheckbox.checked) {
                rooms = rooms.filter( room => {
                    return room.accessibility === "true";
                });
            }
            return rooms;
        },
        sortRooms(rooms, e) {
		    if(e.target.closest('.room-overview__filters__sort-by')) {
                this.sortBySelector = document.querySelector(".room-select-sort-by")

                this.sortBySelector.querySelector("span").innerText = e.target.value;

                const self = this;

                this.sortBySelections.forEach(function (radio) {
                    if (radio.checked) {
                        self.sortOrder = radio.dataset.sortorder;
                    }
                });

                if (self.sortOrder === "Price low to high") {
                    rooms.sort((a, b) => {
                        return a.price - b.price;
                    });
                } else if (self.sortOrder === "Price high to low") {
                    rooms.sort((a, b) => {
                        return b.price - a.price;
                    });
                } else {
                    rooms.sort(function(a, b) {
                        return a.sortOrder - b.sortOrder;
                    });
                }
            }

            return rooms;
        },

        handleDomElements(rooms) {
            //Start by setting them all to display none
            this.nodeList.forEach((item) => {
                item.style.display = "none";
            });

            //then loop through our array
            rooms.forEach((room, index) => {
                const singleRoom = document.getElementById(room.id);
                singleRoom.style.display = "flex";
                singleRoom.style.order = index.toString();
            });

        },

        setUpPersonsCountListeners() {
            this.minusAdult = document.getElementById("minusAdult");
			this.plusAdult = document.getElementById("plusAdult");
			this.minusChildren = document.getElementById("minusChildren");
			this.plusChildren = document.getElementById("plusChildren");
			this.minusInfants = document.getElementById("minusInfants");
			this.plusInfants = document.getElementById("plusInfants");
            
            this.minusAdult.addEventListener(
                "click",
                this.minusAdultCounter,
                true
            );
            this.plusAdult.addEventListener(
                "click",
                this.plusAdultsCounter,
                true
            );
            this.minusChildren.addEventListener(
                "click",
                this.minusChildrenCounter,
                true
            );
            this.plusChildren.addEventListener(
                "click",
                this.plusChildrenCounter,
                true
            );
            this.minusInfants.addEventListener(
                "click",
                this.minusInfantsCounter,
                true
            );
            this.plusInfants.addEventListener(
                "click",
                this.plusInfantsCounter,
                true
            );
		},
		removePersonsCountListeners() {
			if(this.minusAdult) {
                this.minusAdult.removeEventListener(
                    "click",
                    this.minusAdultCounter,
                    true
                );
                this.plusAdult.removeEventListener(
                    "click",
                    this.plusAdultsCounter,
                    true
                );
                this.minusChildren.removeEventListener(
                    "click",
                    this.minusChildrenCounter,
                    true
                );
                this.plusChildren.removeEventListener(
                    "click",
                    this.plusChildrenCounter,
                    true
                );
                this.minusInfants.removeEventListener(
                    "click",
                    this.minusInfantsCounter,
                    true
                );
                this.plusInfants.removeEventListener(
                    "click",
                    this.plusInfantsCounter,
                    true
                );
            }
		},

        updatePersonsSelectorFieldOnClick() {
            const dictionary = JSON.parse(this.personsSelector.dataset.dictionary); 
            
            this.labelValues.adults = this.counterType.adultsCounter;
            this.labelValues.children = this.counterType.childrenCounter;
            this.labelValues.infants = this.counterType.infantsCounter;

            let adultsLabel = "";
            if (this.labelValues.adults != "0" && this.labelValues.adults != undefined) {
                adultsLabel = this.labelValues.adults + (this.labelValues.adults > "1" ? " "+dictionary.AdultsPersonTypePlural : " "+dictionary.AdultsPersonTypeSingular);
            }

            let childrenLabel = "";
            if (this.labelValues.children != "0" && this.labelValues.children != undefined) {
                childrenLabel = this.labelValues.children + (this.labelValues.children > 1 ? " " + dictionary.ChildrenPersonTypePlural : " " + dictionary.ChildrenPersonTypeSingular);
            }

            let infantsLabel = "";
            if (this.labelValues.infants != "0" && this.labelValues.infants != undefined) {
                infantsLabel = this.labelValues.infants + (this.labelValues.infants > "1" ? " " + dictionary.InfantsPersonTypePlural : " " + dictionary.InfantsPersonTypeSingular);
            }

            if ((this.labelValues.adults === 0 || this.labelValues.adults === undefined) && (this.labelValues.children === 0 || this.labelValues.children === undefined) && (this.labelValues.infants === 0 || this.labelValues.infants === undefined)) {
                this.personsSelector.querySelector("span").innerHTML = this.personsSelector.dataset.text;
            } else {
                this.personsSelector.querySelector("span").innerHTML = 
                (this.labelValues.adults != "0" && this.labelValues.adults != undefined && ((this.labelValues.children != "0" && this.labelValues.children != undefined) ||
                        (this.labelValues.infants != "0" && this.labelValues.infants != undefined)) ? adultsLabel + ", " : adultsLabel) + (this.labelValues.children != "0" && this.labelValues.children != undefined 
                        && (this.labelValues.infants != "0" && this.labelValues.infants != undefined) ? childrenLabel + ", " : childrenLabel) + infantsLabel;
            }
        },
        updateRoomTypeSelectorFieldOnClick(e) {
            // Sibllng is span with label (regex removes blank space)
			const currentLabel = e.target.nextElementSibling.textContent.replace(/\s/g, '');

			if (this.roomTypeLabels.length === 0) {
				this.roomTypeLabels.push(currentLabel);
			} else if (this.roomTypeLabels.includes(currentLabel)) {
				for (let i = 0; i < this.roomTypeLabels.length; i++) {
					if (this.roomTypeLabels[i] === currentLabel) {
						this.roomTypeLabels.splice(i, 1);
					}
				}
			} else {
				this.roomTypeLabels.push(currentLabel);
			}
			if (this.roomTypeLabels.length === 0) {
				this.roomTypeSelector.querySelector("span").innerHTML = this.roomTypeSelector.dataset.text;
			} else {
                this.roomTypeSelector.querySelector("span").innerHTML = this.roomTypeLabels.join(", ");
			}
		},

        // Persons filter counters
		minusAdultCounter: function minusAdultCounter(e) {
			this.updatePersonsCount(
				"adultsCounter",
				Number(this.minusAdult.dataset.min),
				"minus"
			);

		},
		plusAdultsCounter: function plusAdultsCounter(e) {
			this.updatePersonsCount(
				"adultsCounter",
				Number(this.plusAdult.dataset.max),
				"plus"
			);

		},
		minusChildrenCounter: function minusChildrenCounter(e) {
			this.updatePersonsCount(
				"childrenCounter",
				Number(this.minusChildren.dataset.min) + 1,
				"minus"
			);

		},
		plusChildrenCounter: function plusChildrenCounter(e) {
			this.updatePersonsCount(
				"childrenCounter",
				Number(this.plusChildren.dataset.max),
				"plus"
			);

		},
		minusInfantsCounter: function minusInfantsCounter(e) {
			this.updatePersonsCount(
				"infantsCounter",
				Number(this.minusInfants.dataset.min) + 1,
				"minus"
			);

		},
		plusInfantsCounter: function plusInfantsCounter(e) {
			this.updatePersonsCount(
				"infantsCounter",
				Number(this.plusInfants.dataset.max),
				"plus"
			);

		},
		updatePersonsCount: function(type, dataMinMax, increment) {
			const currentLimit = dataMinMax;

			if (increment === "minus" && Number(this.counterType[type]) >= currentLimit) {
				this.counterType[type]--;
			} else if (increment === "plus" && Number(this.counterType[type]) <= currentLimit - 1) {
				this.counterType[type]++;
			}
            this.updatePersonsSelectorFieldOnClick();
		},

        // Open/Close modals
        togglePeopleModal() {
            this.showPersonsModal = !this.showPersonsModal;
        },
        closePersonModal(e) {
            if (!e.target.closest('.room-overview__filters__persons')) {
                this.showPersonsModal = false;
		        this.removePersonsCountListeners();
            }
        },
        toggleRoomTypesModal() {
            this.showRoomTypesModal = !this.showRoomTypesModal;
        },
        closeRoomTypesModal(e) {
            if (!e.target.closest('.room-overview__filters__room-type')) {
                this.showRoomTypesModal = false;
            }
        },
        toggleSortByModal() {
            this.showSortByModal = !this.showSortByModal;
        },
        closeSortByModal(e) {
            if (!e.target.closest('.room-overview__filters__sort-by')) {
                this.showSortByModal = false;
            }
        }	
    }
});
